{
  "$schema": "../extension_schema.json",
  "name": "editManualEvent",
  "enabled": false,
  "contextCharacteristics": [
    {
      "kind": "Capsule",
      "defaultValue": false,
      "proxyKind": "selected",
      "eventTimeRepresentation": "capsule",
      "reducer": "set"
    }
  ],
  "uiConfig": {
    "iconRepresentation": {
      "isUniqueValueSet": true,
      "defaultRepresentation": false,
      "discreteStates": [
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.EDIT_EVENT.EDIT_EVENT",
          "value": true,
          "iconClass": "fa-pencil"
        },
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.EDIT_EVENT.EDIT_EVENT",
          "value": false,
          "iconClass": "fa-pencil",
          "iconFill": "white"
        }
      ],
      "mixedStates": {
        "labelTranslationKey": "VANTAGE.EXTENSIONS.EDIT_EVENT.EDIT_EVENT",
        "iconClass": "fa-pencil"
      }
    },
    "consoleToolbarConfiguration": {
      "sortOrder": 4,
      "onClick": "deferToComponentUI",
      "componentUi": "ManualEventPortal",
      "portal": "customModal",
      "titleTranslationKey": "VANTAGE.EXTENSIONS.EDIT_EVENT.TITLE"
    }
  }
}
